export default "__VITE_ASSET__9daff4a7__"